import useCancelOrder from '@activities/order/CancelOrderModal/hooks/useCancelOrder';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Params {
    orderNo: string;
}

declare module '@stackflow/config' {
    interface Register {
        CancelOrderModal: Params;
    }
}

const CancelOrderModal: ActivityComponentType<'CancelOrderModal'> = ({ params }) => {
    const { t } = useTranslation('orderLog');
    const { orderNo } = params;
    const { pop } = useFlow();
    const cancelOrder = useCancelOrder(orderNo);
    return (
        <Modal>
            <ModalContainer>
                <Column align='center' fullWidth spacing={28}>
                    <Column fullWidth align='center' spacing={8}>
                        <Text size='2xl' fontWeight='bold'>{t('cancelModal.title')}</Text>
                        <Text size='lg'>{t('cancelModal.message')}</Text>
                    </Column>
                    <Row spacing={10} fullWidth>
                        <Button fullWidth variant='secondary'
                            noPadding
                            onClick={cancelOrder}>
                            {t('cancelModal.confirm')}
                        </Button>
                        <Button fullWidth onClick={pop} noPadding>{t('cancelModal.cancel')}</Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default CancelOrderModal;
